import React from "react";
import { find } from "lodash";
import Dropdown from "@radarly/components/panels/card-edition/sidebar/dropdown";
import { useCurrentProjectFocusesId } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { setCardComparaisonPeriod } from "@radarly/models/cards/editor";
import {
  getComparaisonPeriodFromCard,
  isComparisonPeriodFromCardBothPreviousAndLastYearPeriod,
} from "@radarly/models/cards/form";
import { ComparisonPeriod } from "@radarly/models/cards/period";

export interface SharedPanelsCardEditionSidebarPeriodEvolutionProps {
  card: Card;
  setCard: (card: Card) => void;
}

export default function SharedPanelsCardEditionSidebarPeriodEvolution({
  card,
  setCard,
}: SharedPanelsCardEditionSidebarPeriodEvolutionProps) {
  const workspaceId = useCurrentWorkspaceId();
  const projectFocuses = useCurrentProjectFocusesId();
  const locale = useCurrentUserLocale();
  const isPreviousYearOptionDisabled =
    isComparisonPeriodFromCardBothPreviousAndLastYearPeriod(card);
  const comparisonPeriod = getComparaisonPeriodFromCard(card);
  const options = [
    {
      value: "previous_period",
      label: tr(
        locale,
        "CUSTOM_PAGES::EDITOR::DATAVIZ::COMPARE_PREVIOUS_PERIOD"
      ),
    },
    ...(!isPreviousYearOptionDisabled
      ? [
          {
            value: "last_year",
            label: tr(
              locale,
              "CUSTOM_PAGES::EDITOR::DATAVIZ::COMPARE_PREVIOUS_YEAR"
            ),
          },
        ]
      : []),
    { value: null, label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::NO") },
  ];
  const option = find(options, { value: comparisonPeriod }) || options[2];
  return (
    <Dropdown
      label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::PERIOD_EVOLUTION")}
      value={option}
      options={options}
      onChange={({ value }) =>
        setCard(
          setCardComparaisonPeriod(
            workspaceId,
            projectFocuses,
            card,
            value as ComparisonPeriod
          )
        )
      }
    />
  );
}
